import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="relative flex items-center justify-center overflow-hidden pt-[0px] pb-[40px] bg-[#fdf8f3]" data-id="element-160" data-mp="3fibc2y6pqr4y">
      {/* Dynamic Background Effects */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-161" data-mp="3kb4h7n63g1hk">
        {/* Animated Glows */}
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.1, 0.2, 0.1]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[1000px] h-[800px] bg-[#d97706]/10 rounded-full blur-[140px] will-change-transform" data-id="element-162" data-mp="2bdx4inrvvln8" />

        {/* Grid Pattern with Mask */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(139,92,24,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(139,92,24,0.05)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_70%)] opacity-40" data-id="element-163" data-mp="2u3mxd5c35xci" />
      </div>

      <div className="relative z-10 w-full text-center flex flex-col items-center" data-id="element-164" data-mp="1dr7sdl3gvsnn">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full flex flex-col items-center gap-2" data-id="element-165" data-mp="18rv8983zczor">
          {/* Main Hero Image */}
          <div className="relative w-full" data-id="element-166" data-mp="3msug4dlk75x4">
            <img src="https://cdn.magicpatterns.com/uploads/n5F6mpo3wysfCxxAyyyD2u/Libro_1_WEb.webp" alt="Guía Digital Resina Epóxica" className="w-full h-auto rounded-none shadow-none block" fetchPriority="high" loading="eager" decoding="sync" data-id="element-167" data-mp="3mtvr6i2krseu" />
          </div>

          {/* Payment CTA Button */}
          <motion.button whileHover={{
          scale: 1.05,
          boxShadow: '0 0 40px rgba(245, 197, 24, 0.6)'
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPricing} className="relative group overflow-hidden bg-gradient-to-b from-[#f5c518] to-[#d97706] text-black font-black text-xl md:text-2xl px-8 py-4 rounded-2xl uppercase tracking-wider transition-all border-b-4 border-[#92400e] w-auto shadow-[0_10px_20px_rgba(0,0,0,0.4)] pt-[20px] pb-[20px] pl-[0px] pr-[0px] -mt-12 md:-mt-20" data-id="element-168" data-mp="aae3vmrfrpdl">
            <span className="relative z-10 flex items-center gap-3" data-id="element-169" data-mp="1pvygbin0nw6j">
              QUIERO ACCEDER AHORA
              <motion.span animate={{
              x: [0, 5, 0]
            }} transition={{
              duration: 1.5,
              repeat: Infinity
            }} data-id="element-170" data-mp="2mke9rpt8ypox">
                🚀
              </motion.span>
            </span>

            {/* Enhanced Shimmer effect */}
            <motion.div animate={{
            left: ['-100%', '150%']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
            repeatDelay: 1
          }} className="absolute top-0 bottom-0 w-20 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[30deg] pointer-events-none" data-id="element-171" data-mp="368n0rwj20pmu" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}